enum AuctionStatus {
  Completed = "completed",
  HoldingPeriod = "holding_period",
  NotStarted = "not_started",
  Ongoing = "ongoing",
}

export default AuctionStatus;
